import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Home page hero — content sits in the LEFT portion of the section;
 * the modern-farmhouse counter scene (truenooch-home-hero.webp — a paper-wrapped
 * log with coins fanned on a board, a jar of cubes, window light) fills the right
 * side as the section background. CSS overlay darkens the left for text legibility;
 * background-position: right center keeps the product in frame on tall viewports.
 *
 * background-image is set inline (not in App.css) because CRA's
 * css-loader tries to resolve url(/...) paths as webpack modules from
 * src/ and fails. Setting via process.env.PUBLIC_URL resolves it at
 * runtime against the public/ directory where the image actually lives.
 */
export function Hero() {
  const heroBg = `url(${process.env.PUBLIC_URL}/images/brand/truenooch-home-hero.webp)`;
  return (
    <div className="hero" style={{ backgroundImage: heroBg }}>
      <div className="hero-content">
        <div className="hero-badge">Made in Colorado</div>
        <h1>
          <span className="brand">TrueNooch</span>
          <span className="tm">&trade;</span>
        </h1>
        <p className="hero-sub">
          Slice off a round.<br />
          Deep, savory umami that makes everything it touches taste better.<br />
          A plant-based whole food — real ingredients you can name.
        </p>
        <div className="hero-chips">
          <span className="chip">Organic</span>
          <span className="chip">Nut-Free</span>
          <span className="chip">Soy-Free</span>
          <span className="chip">Gluten-Free</span>
          <span className="chip">Vegan</span>
          <span className="chip">Complete Protein</span>
        </div>
        <Link className="club-cta hero-cta" to="/club">Order direct &rarr;</Link>
      </div>
      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-arrow"></div>
      </div>
    </div>
  );
}
